import React from 'react'
import { Container } from 'react-bootstrap'

function Contact() {
  return (
    <Container fluid className="about-section">
        <h1>Contact Me 📨 </h1>
        <iframe title="ContactForm" src="https://docs.google.com/forms/d/e/1FAIpQLSdmPQ_m8RXlIX4pMnzHV8e03-KuKtHG5dmUBlJgfacvZ3ijjA/viewform?embedded=true" width="1100" height="837" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
    </Container>
  )
}

export default Contact
